var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.09156 2.22316C3.51938 2.0051 4.07948 2.00504 5.19967 2.00493L14.7991 2.00391C15.9193 2.00379 16.4794 2.00373 16.9072 2.2217C17.2836 2.41344 17.5896 2.7194 17.7814 3.09575C17.9994 3.52359 17.9994 4.0837 17.9994 5.20391V14.7991C17.9994 15.9192 17.9994 16.4793 17.7814 16.9071C17.5897 17.2834 17.2837 17.5894 16.9074 17.7812C16.4796 17.9991 15.9195 17.9991 14.7994 17.9991H5.20188C4.08197 17.9991 3.52202 17.9991 3.09424 17.7812C2.71795 17.5895 2.412 17.2836 2.22022 16.9074C2.00221 16.4796 2.0021 15.9197 2.00188 14.7998L2.00001 5.20555C1.9998 4.08535 1.99969 3.52526 2.21761 3.09737C2.40931 2.72099 2.71524 2.41497 3.09156 2.22316ZM13.2502 6.50171C13.2502 6.0875 12.9145 5.75171 12.5002 5.75171C12.086 5.75171 11.7502 6.0875 11.7502 6.50171V13.5017C11.7502 13.9159 12.086 14.2517 12.5002 14.2517C12.9145 14.2517 13.2502 13.9159 13.2502 13.5017V6.50171ZM8.25024 10.5017C8.25024 10.0875 7.91446 9.75171 7.50024 9.75171C7.08603 9.75171 6.75024 10.0875 6.75024 10.5017V13.5017C6.75024 13.9159 7.08603 14.2517 7.50024 14.2517C7.91446 14.2517 8.25024 13.9159 8.25024 13.5017V10.5017Z",
    fill: "#9A9FA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.67a87b6e849f2eb3ef51daeecef72215.svg";
export { ForwardRef as ReactComponent };